export const inputRules = [
  v => !!v || "This field is required"
];

export const avatarRules = [
  v => !!v || "This field is required",
  v => /^.{1,255}$/.test(v) || "Maximum 512 characters"
];

export const emailRules = [
  v => !!v || "E-mail is required",
  v => /.+@.+/.test(v) || "E-mail must be valid"
];

export const updateEmailRules = [
  v => /.+@.+/.test(v) || "E-mail must be valid"
];

export const updatePhoneRules = [
  v => /^[\s\S]{12}$/.test(v) || "10 digits, numbers only."
];

export const updatePostalRules = [
  v => /^[\s\S]{5}$/.test(v) || "5 digits, numbers only."
];

export const updateLicenseRules = [
  v => !!v || "This field is required",
  v => /^[a-z0-9]{3,}$/i.test(v) || "This field must contain at least 3 characters"
];

export const passwordRules = [
  v => !!v || "Password is required",
  v => /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/.test(v) ||
        "Password must contain at least 8 characters, including one number and one special character"
];

export const ccRules = [
  v => !!v || "Credit card number required",
  v => /^[\s\S]{19}$/.test(v) || "Standard CC Format: #### #### #### ####"
];

export const amexRules = [
  v => !!v || "Credit card number required",
  v => /^[\s\S]{17,19}$/.test(v) || "AMEX CC Format: #### ###### #####"
];

export const cvvRules = [
  v => !!v || "CVV code required",
  v => /^[0-9]{3}$/.test(v) || "3 digit number required"
];

export const amexCvvRules = [
  v => !!v || "CVV code required",
  v => /^[0-9]{4}$/.test(v) || "4 digit number required"
];

export const cvvAmexRules = [
  v => !!v || "CVV code required",
  v => /^[0-9]{4}$/.test(v) || "Format: ####"
];

export default {
  avatarRules: avatarRules,
  inputRules: inputRules,
  emailRules: emailRules,
  passwordRules: passwordRules
};
